export default "__VITE_ASSET__COY6Hx0B__"